(function() {
  'use strict';

  // Scroll Reveal
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          revealObserver.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.lp-oakwoods .lp-reveal').forEach(function(el) {
      revealObserver.observe(el);
    });
  } else {
    document.querySelectorAll('.lp-oakwoods .lp-reveal').forEach(function(el) {
      el.classList.add('is-visible');
    });
  }

  // CTA anchor fallback
  document.querySelectorAll('.lp-oakwoods a[href="#product-form"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var form = document.querySelector('#product-form')
        || document.querySelector('[data-type="add-to-cart-form"]')
        || document.querySelector('form[action*="/cart/add"]')
        || document.querySelector('.product-form');
      if (form) {
        e.preventDefault();
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

})();